"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var with_mparticle_listings_1 = require("@reverbdotcom/commons/dist/components/with_mparticle_listings");
var bind_1 = require("@reverbdotcom/commons/dist/bind");
var api_request_1 = require("./api_request");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
function track(listing, productActionType) {
    if (!listing)
        return;
    mparticle_tracker_1.trackEvent({
        listing: listing,
        productActionType: productActionType,
        eventName: mparticle_tracker_1.MParticleEventName.ProductAction,
    });
}
var CartItemActions = /** @class */ (function (_super) {
    tslib_1.__extends(CartItemActions, _super);
    function CartItemActions(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showConfirmation: false,
        };
        return _this;
    }
    Object.defineProperty(CartItemActions.prototype, "listingId", {
        get: function () {
            return this.props.listingIds[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartItemActions.prototype, "listing", {
        get: function () {
            return this.props.mParticleListings[0];
        },
        enumerable: true,
        configurable: true
    });
    CartItemActions.prototype.moveToWatchList = function () {
        var _this = this;
        api_request_1.post("/cart/" + this.props.cartItemId + "/move_to_watchlist", {}, {}, '3.0').then(function () {
            track(_this.listing, mparticle_tracker_1.ProductActionType.RemoveFromCart);
            track(_this.listing, mparticle_tracker_1.ProductActionType.AddToWishlist);
            window.location.reload();
        });
    };
    CartItemActions.prototype.removeFromCart = function () {
        var _this = this;
        api_request_1.destroy("/cart/" + this.listingId, {}, {}, '3.0').then(function () {
            track(_this.listing, mparticle_tracker_1.ProductActionType.RemoveFromCart);
            window.location.reload();
        });
    };
    CartItemActions.prototype.setConfirmation = function (showConfirmation) {
        this.setState({ showConfirmation: showConfirmation });
    };
    CartItemActions.prototype.render = function () {
        var _this = this;
        var _a = this.props, canMoveToWatchList = _a.canMoveToWatchList, canRemoveFromCart = _a.canRemoveFromCart, isBundledListing = _a.isBundledListing;
        var confirmationSectionClasses = classNames('mobile-width-100 mtb-half panel pull-left', { hidden: !this.state.showConfirmation });
        var buttonClasses = classNames('inline-list mt-half small', { hidden: this.state.showConfirmation });
        var confirmationKey = isBundledListing ? 'confirmationWithBundle' : 'confirmation';
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: buttonClasses },
                canMoveToWatchList &&
                    React.createElement("li", { className: "margined-right hidden-mobile" },
                        React.createElement("a", { className: "color-gray", "data-move-to-watchlist": true, onClick: this.moveToWatchList, rel: "nofollow" },
                            React.createElement("span", { className: "fa fa-star" }),
                            " ",
                            I18n.t('discovery.removeFromCart.moveToWatchList'))),
                canRemoveFromCart &&
                    React.createElement("li", null,
                        React.createElement("a", { className: "color-gray remove-link", "data-toggle-confirmation": true, onClick: function () { return _this.setConfirmation(true); }, rel: "nofollow" },
                            React.createElement("span", { className: "fa fa-times" }),
                            " ",
                            I18n.t('discovery.removeFromCart.remove')))),
            React.createElement("div", { className: "clearfix" },
                React.createElement("div", { className: confirmationSectionClasses, "data-confirmation-section": true },
                    React.createElement("p", { className: "small mb-half" }, I18n.t("discovery.removeFromCart." + confirmationKey)),
                    React.createElement("a", { className: "button button--mini mobile-width-100 mobile-mb-half", "data-cancel-remove-from-cart": true, onClick: function () { return _this.setConfirmation(false); }, rel: "nofollow" }, I18n.t('discovery.removeFromCart.no')),
                    "\u00A0",
                    React.createElement("a", { className: "button button--mini mobile-width-100", "data-confirm-remove-from-cart": true, onClick: this.removeFromCart, rel: "nofollow" }, I18n.t('discovery.removeFromCart.yes'))))));
    };
    CartItemActions.defaultProps = {
        mParticleListings: [],
    };
    tslib_1.__decorate([
        bind_1.default
    ], CartItemActions.prototype, "moveToWatchList", null);
    tslib_1.__decorate([
        bind_1.default
    ], CartItemActions.prototype, "removeFromCart", null);
    tslib_1.__decorate([
        bind_1.default
    ], CartItemActions.prototype, "setConfirmation", null);
    return CartItemActions;
}(React.Component));
exports.CartItemActions = CartItemActions;
exports.default = with_mparticle_listings_1.default()(CartItemActions);
//# sourceMappingURL=cart_item_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/cart_item_actions.js
// module id = zvYI
// module chunks = 20 21